import React from 'react';
import { FolderOpen, Brain, FileText, BookOpen, Zap, Check, Star, ShieldCheck, Clock, Heart, Users, Menu, Flame } from 'lucide-react';
import { CTAButton } from './components/CTAButton';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  const checkoutUrl = 'https://checkout.ebookditales.com/cart/42659101540415:1';
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-purple-50 via-white to-gray-50 font-sans text-gray-900" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* Top Announcement Bar */}
      <div className="bg-gradient-to-r from-purple-700 to-purple-600 text-white py-2 px-4 text-center sticky top-0 z-50 shadow-md" data-id="element-2">
        <p className="font-bold text-xs md:text-base flex items-center justify-center gap-2" data-id="element-3">
          <Flame className="w-4 h-4 md:w-5 md:h-5" data-id="element-4" />
          OFERTA LIMITADA: 60% DE DESCUENTO HOY
        </p>
      </div>

      {/* Hero Section - Centered Layout */}
      <header className="py-4 md:py-20 px-4" data-id="element-5">
        <div className="max-w-4xl mx-auto text-center" data-id="element-6">
          {/* Badge */}
          <div className="inline-flex items-center gap-1.5 bg-white border-2 border-purple-200 text-purple-800 px-3 py-1.5 rounded-full text-xs md:text-sm font-bold mb-3 md:mb-8 shadow-sm" data-id="element-7">
            <Brain className="w-3 h-3 md:w-4 md:h-4" data-id="element-8" />
            MEGA PACK TERAPÉUTICO™
          </div>

          {/* Headline */}
          <h1 className="text-2xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-3 md:mb-8 px-2" data-id="element-9">
            Mega Pack Terapéutico Para Psicólogas{' '}
            <span className="text-purple-600" data-id="element-10">
              6 meses de actividades listas para usar sin planificar nada
            </span>
          </h1>

          {/* Product Image */}
          <div className="mb-3 md:mb-8 flex justify-center" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/ekXi9VodxrBsDJ8qryi7h5/MOCK_UP_PSICOLOGA-removebg-preview.png" alt="Mega Pack Terapéutico" className="w-full max-w-[200px] md:max-w-md drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-12" />
          </div>

          {/* Subheadline */}
          <p className="text-sm md:text-xl text-gray-600 mb-4 md:mb-10 max-w-2xl mx-auto leading-relaxed px-4" data-id="element-13">
            Empezá el 2026 con tus sesiones organizadas listo en PDF para
            aplicar en cualquier sesión, creado por psicólogas profesionales.
          </p>
          <p className="text-xs md:text-lg text-gray-500 mb-4 md:mb-10 font-medium" data-id="element-14">
            Sin improvisar. Sin perder horas. Sin estrés.
          </p>

          {/* CTA Button */}
          <div className="mb-3 md:mb-6 px-4" data-id="element-15">
            <a href={checkoutUrl} className="inline-flex items-center justify-center bg-gradient-to-r from-purple-700 to-purple-600 hover:from-purple-800 hover:to-purple-700 text-white font-bold text-sm md:text-lg px-6 py-3 md:px-10 md:py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300" data-id="element-16">
              SÍ, QUIERO EL MEGA PACK TERAPÉUTICO™
              <span className="ml-2" data-id="element-17">→</span>
            </a>
          </div>
          <p className="text-xs md:text-sm text-gray-500 mb-4 md:mb-12" data-id="element-18">
            Garantía de satisfacción de 7 días
          </p>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-2 md:gap-3 text-xs md:text-sm text-gray-600" data-id="element-19">
            <div className="flex -space-x-2" data-id="element-20">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-7 h-7 md:w-10 md:h-10 rounded-full bg-gray-200 border-2 border-white overflow-hidden" data-id="element-21">
                  <img src={`https://i.pravatar.cc/100?img=${i + 20}`} alt="User" className="w-full h-full object-cover" data-id="element-22" />
                </div>)}
            </div>
            <p className="font-medium" data-id="element-23">Más de 1,200 psicólogas ya lo usan</p>
          </div>
        </div>
      </header>

      {/* What's Included Section */}
      <section className="py-20 px-4 bg-white" data-id="element-24">
        <div className="max-w-5xl mx-auto" data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-27">
              ¿Qué incluye este sistema?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-28">
              Un pack pensado por psicólogas, para psicólogas. Material
              organizado para 6 meses de trabajo terapéutico.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29">
            {[{
            icon: FolderOpen,
            title: '24 Sesiones Completas',
            desc: 'Listas para usar. Material organizado para 6 meses de trabajo, adaptable a distintas edades.'
          }, {
            icon: Brain,
            title: 'Protocolos Clínicos',
            desc: 'Intervenciones claras y organizadas para aplicar con seguridad, sin improvisar en sesión.'
          }, {
            icon: FileText,
            title: 'Hojas de Trabajo',
            desc: 'Material profesional imprimible para usar en sesión o entregar al paciente en segundos.'
          }, {
            icon: BookOpen,
            title: 'Mini-guías de Intervención',
            desc: 'Apoyo práctico y teórico para distintos momentos clave del proceso terapéutico.'
          }, {
            icon: Zap,
            title: 'Acceso Inmediato',
            desc: 'Todo el contenido disponible en PDF digital desde el primer momento de tu compra.'
          }, {
            icon: Star,
            title: 'Calidad Profesional',
            desc: 'Diseñado estéticamente para transmitir profesionalismo y confianza a tus pacientes.'
          }].map((item, idx) => <div key={idx} className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-shadow border border-gray-100" data-id="element-30">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-31">
                  <item.icon className="w-6 h-6" data-id="element-32" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-33">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-34">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="py-16 px-4 bg-purple-900 text-white" data-id="element-35">
        <div className="max-w-4xl mx-auto text-center" data-id="element-36">
          <h2 className="text-3xl font-bold mb-12" data-id="element-37">
            Material listo y probado para:
          </h2>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-38">
            {['Sesiones individuales', 'Psicología clínica', 'Terapia Cognitivo-Conductual', 'Consultorio privado', 'Organización del proceso', 'Seguimiento de pacientes', 'Terapia Online', 'Talleres Grupales'].map((tag, idx) => <span key={idx} className="bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-full text-lg font-medium" data-id="element-39">
                ✅ {tag}
              </span>)}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-40">
        <div className="max-w-6xl mx-auto" data-id="element-41">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-42">
            {/* Patient Benefits */}
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gray-100" data-id="element-43">
              <div className="flex items-center gap-4 mb-8" data-id="element-44">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-45">
                  <Heart className="w-8 h-8 text-blue-600" data-id="element-46" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-47">
                  ¿Qué logran tus pacientes?
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-48">
                {['Mayor claridad en el proceso terapéutico', 'Mejor adherencia al tratamiento', 'Sesiones más estructuradas y productivas', 'Continuidad real en el trabajo personal', 'Mayor sensación de seguridad y contención'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-49">
                    <Check className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" data-id="element-50" />
                    <span className="text-gray-700 text-lg" data-id="element-51">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Psychologist Benefits */}
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-2 border-purple-100 relative overflow-hidden" data-id="element-52">
              <div className="absolute top-0 right-0 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-53">
                PARA VOS
              </div>
              <div className="flex items-center gap-4 mb-8" data-id="element-54">
                <div className="bg-purple-100 p-3 rounded-full" data-id="element-55">
                  <Users className="w-8 h-8 text-purple-600" data-id="element-56" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-57">
                  ¿Qué lográs vos?
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-58">
                {['Ahorrar horas de planificación cada semana', 'Dejar de improvisar minutos antes de la sesión', 'Sentirte más segura y profesional', 'Tener un sistema claro de trabajo', 'Reducir la carga mental y el burnout', 'Volver a disfrutar tu práctica profesional'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-59">
                    <Check className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" data-id="element-60" />
                    <span className="text-gray-700 text-lg font-medium" data-id="element-61">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-white" data-id="element-62">
        <div className="max-w-6xl mx-auto" data-id="element-63">
          <div className="text-center mb-16" data-id="element-64">
            <span className="text-purple-600 font-bold tracking-wider uppercase" data-id="element-65">
              Solo por hoy
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-66">
              🎁 BONOS EXCLUSIVOS (GRATIS HOY)
            </h2>
            <p className="text-xl text-gray-600" data-id="element-67">
              Llevate estos 3 recursos adicionales totalmente gratis al adquirir
              el Mega Pack hoy.
            </p>
          </div>

          <div className="space-y-16" data-id="element-68">
            {/* Bonus 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-69">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-70">
                <img src="https://cdn.magicpatterns.com/uploads/hAfUsYL4tdAkbCYMw4BLKg/BONO_1_PSICOLOGIA.png" alt="Mapa Terapéutico" className="rounded-xl shadow-xl w-full max-w-sm hover:scale-105 transition-transform duration-300" data-id="element-71" />
              </div>
              <div className="w-full md:w-1/2 space-y-4" data-id="element-72">
                <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold" data-id="element-73">
                  VALOR: $23.000 ARS (HOY GRATIS)
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-74">
                  Bono 1 – Mapa Terapéutico
                </h3>
                <p className="text-gray-600" data-id="element-75">
                  Un mapa visual que resume todo el recorrido terapéutico. Ideal
                  para tener siempre a mano en el consultorio.
                </p>
                <ul className="space-y-2" data-id="element-76">
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-77">
                    <Check className="w-4 h-4 text-green-500" data-id="element-78" /> Ver el proceso
                    completo
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-79">
                    <Check className="w-4 h-4 text-green-500" data-id="element-80" /> Organizar fases
                    y técnicas
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-81">
                    <Check className="w-4 h-4 text-green-500" data-id="element-82" /> Trabajar con
                    mayor orden
                  </li>
                </ul>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12" data-id="element-83">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-84">
                <img src="https://cdn.magicpatterns.com/uploads/iAR7eRETuDj5uFN5x2Uu8c/bono_2_PSICOLOGIA.png" alt="Checklist Inicial" className="rounded-xl shadow-xl w-full max-w-sm hover:scale-105 transition-transform duration-300" data-id="element-85" />
              </div>
              <div className="w-full md:w-1/2 space-y-4" data-id="element-86">
                <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold" data-id="element-87">
                  VALOR: $15.000 ARS (HOY GRATIS)
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-88">
                  Bono 2 – Checklist Inicial
                </h3>
                <p className="text-gray-600" data-id="element-89">
                  Los pasos clave que tu paciente debe seguir desde el primer
                  día. Perfecto para entregar al comenzar.
                </p>
                <ul className="space-y-2" data-id="element-90">
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-91">
                    <Check className="w-4 h-4 text-green-500" data-id="element-92" /> Ordenar el
                    inicio del tratamiento
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-93">
                    <Check className="w-4 h-4 text-green-500" data-id="element-94" /> Evitar
                    confusiones y dudas
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-95">
                    <Check className="w-4 h-4 text-green-500" data-id="element-96" /> Generar
                    adherencia inmediata
                  </li>
                </ul>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-97">
              <div className="w-full md:w-1/2 flex justify-center" data-id="element-98">
                <img src="https://cdn.magicpatterns.com/uploads/afcNoRPXVsYQLsSTM4w985/BONO_3_PSICOLOGIA.png" alt="Kit de Mensajes" className="rounded-xl shadow-xl w-full max-w-sm hover:scale-105 transition-transform duration-300" data-id="element-99" />
              </div>
              <div className="w-full md:w-1/2 space-y-4" data-id="element-100">
                <div className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-bold" data-id="element-101">
                  VALOR: $18.000 ARS (HOY GRATIS)
                </div>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-102">
                  Bono 3 – Kit de Mensajes
                </h3>
                <p className="text-gray-600" data-id="element-103">
                  21 mensajes listos para enviar por WhatsApp. Reduce abandono y
                  fortalece el vínculo.
                </p>
                <ul className="space-y-2" data-id="element-104">
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-105">
                    <Check className="w-4 h-4 text-green-500" data-id="element-106" /> Mensajes
                    anti-ansiedad
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-107">
                    <Check className="w-4 h-4 text-green-500" data-id="element-108" /> Recordatorios
                    motivacionales
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-109">
                    <Check className="w-4 h-4 text-green-500" data-id="element-110" /> Seguimiento
                    entre sesiones
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-purple-50 to-white" data-id="element-111">
        <div className="max-w-4xl mx-auto" data-id="element-112">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-purple-100" data-id="element-113">
            <div className="bg-purple-600 text-white p-4 text-center" data-id="element-114">
              <p className="font-bold text-lg tracking-wide" data-id="element-115">
                OFERTA ESPECIAL POR LANZAMIENTO
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-116">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-117">
                MEGA PACK TERAPÉUTICO™
              </h2>
              <p className="text-purple-600 font-medium text-lg mb-8" data-id="element-118">
                + 3 bonos exclusivos de regalo
              </p>

              <div className="flex flex-col items-center justify-center mb-8" data-id="element-119">
                <p className="text-gray-400 line-through text-xl mb-2" data-id="element-120">
                  Antes $49.900 ARS
                </p>
                <div className="flex items-center gap-3" data-id="element-121">
                  <span className="text-4xl md:text-6xl font-extrabold text-gray-900" data-id="element-122">
                    $19.990 ARS
                  </span>
                </div>
                <div className="mt-2 bg-yellow-100 text-yellow-800 px-4 py-1 rounded-full font-bold text-sm" data-id="element-123">
                  o $13 USD para otros países
                </div>
              </div>

              <div className="max-w-md mx-auto space-y-4 mb-10" data-id="element-124">
                <div className="flex items-center gap-2 text-gray-600 justify-center" data-id="element-125">
                  <Zap className="w-5 h-5 text-purple-500" data-id="element-126" />
                  <span data-id="element-127">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600 justify-center" data-id="element-128">
                  <FolderOpen className="w-5 h-5 text-purple-500" data-id="element-129" />
                  <span data-id="element-130">Descarga ilimitada</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600 justify-center" data-id="element-131">
                  <ShieldCheck className="w-5 h-5 text-purple-500" data-id="element-132" />
                  <span data-id="element-133">Garantía de 7 días</span>
                </div>
              </div>

              <CTAButton href={checkoutUrl} variant="primary" fullWidth className="max-w-lg mx-auto text-xl py-5 animate-pulse" data-id="element-134">
                SÍ, QUIERO EL MEGA PACK
              </CTAButton>

              <p className="text-xs text-gray-400 mt-6" data-id="element-135">
                Pago seguro y encriptado. Recibís el acceso automáticamente en
                tu email.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-136">
        <div className="max-w-6xl mx-auto" data-id="element-137">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-16" data-id="element-138">
            Lo que dicen otras psicólogas
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-139">
            {[{
            name: 'Carla',
            role: 'Psicóloga Clínica',
            text: 'Llegaba a las sesiones corriendo y sin tiempo para preparar nada. Con el Mega Pack tengo todo armado: ejercicios, protocolos e ideas claras. Ahora atiendo más tranquila y mis pacientes lo notan.'
          }, {
            name: 'Lucía',
            role: 'Terapia Cognitivo Conductual',
            text: 'Las 24 sesiones listas me ahorraron horas cada semana. Por primera vez siento que tengo un sistema real y no estoy improvisando todo el tiempo.'
          }, {
            name: 'Sofía',
            role: 'Psicóloga de Adultos',
            text: 'El Mapa Terapéutico y el Checklist inicial ordenaron totalmente mi forma de trabajar. Hoy tengo menos carga mental y puedo enfocarme más en cada paciente.'
          }, {
            name: 'María',
            role: 'Psicóloga Infantil',
            text: 'Estaba agotada de buscar recursos en internet. Este pack tiene justo lo que necesito, con una estética hermosa que a mis pacientes les encanta. Vale cada centavo.'
          }, {
            name: 'Ana',
            role: 'Psicoterapeuta',
            text: 'La mejor inversión que hice para mi consultorio este año. Los protocolos me dieron una seguridad que no tenía antes. Súper recomendado.'
          }].map((testimonial, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-140">
                <div className="flex items-center gap-1 mb-4" data-id="element-141">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-142" />)}
                </div>
                <p className="text-gray-600 mb-6 italic" data-id="element-143">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-144">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 font-bold" data-id="element-145">
                    {testimonial.name[0]}
                  </div>
                  <div data-id="element-146">
                    <p className="font-bold text-gray-900" data-id="element-147">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-148">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-white" data-id="element-149">
        <div className="max-w-3xl mx-auto text-center" data-id="element-150">
          <ShieldCheck className="w-16 h-16 text-purple-600 mx-auto mb-6" data-id="element-151" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-152">
            Garantía sin vueltas
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-153">
            Probá el material durante 7 días. Si sentís que no ordena tus
            sesiones, te devolvemos el 100% del dinero. Sin preguntas. Sin letra
            chica.
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-purple-900 text-white text-center" data-id="element-154">
        <div className="max-w-4xl mx-auto" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-156">
            No sigas improvisando tu práctica profesional
          </h2>
          <p className="text-xl text-purple-100 mb-10 max-w-2xl mx-auto" data-id="element-157">
            Sumate a las psicólogas que ya trabajan con más orden, claridad y
            menos desgaste.
          </p>

          <div className="bg-white/10 backdrop-blur-md p-8 rounded-3xl max-w-2xl mx-auto border border-white/20" data-id="element-158">
            <h3 className="text-2xl font-bold mb-2" data-id="element-159">MEGA PACK TERAPÉUTICO™</h3>
            <p className="text-lg mb-8 opacity-90" data-id="element-160">
              Oferta 50% OFF por tiempo limitado
            </p>
            <CTAButton href={checkoutUrl} variant="secondary" fullWidth className="text-lg" data-id="element-161">
              Sí, quiero la oferta ahora
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-162">
        <p className="mb-4" data-id="element-163">
          © 2024 PsicoRecursos. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4" data-id="element-164">
          <a href="#" className="hover:text-white" data-id="element-165">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white" data-id="element-166">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white" data-id="element-167">
            Contacto
          </a>
        </div>
      </footer>
    </div>;
}